module.exports = __webpack_public_path__ + "f5ddfd41925be02392347f1cf1e68c7e.png";